import { MenuItem, Box, Checkbox, Typography } from '@mui/material';
import React from 'react';
import { ListChildComponentProps, VariableSizeList } from 'react-window';

import { palette } from '../theme';
const LISTBOX_PADDING = 8;

function renderRow(props: ListChildComponentProps) {
  const { data, index, style } = props;
  const [optionProps, option, state] = data[index] as any;
  const { key, ...liProps } = optionProps;

  return (
    <MenuItem key={key} {...liProps} style={{ ...style, top: (style.top as number) + LISTBOX_PADDING }}>
      <Checkbox checked={state?.selected} sx={{ mr: 1 }} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body1">{option.fullName}</Typography>
        {option.email && (
          <Typography variant="body2" color={palette.sidebar.textMuted}>
            ({option.email})
          </Typography>
        )}
      </Box>
    </MenuItem>
  );
}

const OuterElementContext = React.createContext<Record<string, any>>({});

const OuterElementType = React.forwardRef<HTMLDivElement>((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

function useResetCache(data: any) {
  const ref = React.useRef<VariableSizeList>(null);
  React.useEffect(() => {
    ref.current?.resetAfterIndex(0, true);
  }, [data]);
  return ref;
}

const ListboxComponent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLElement>>(function ListboxComponent(props, ref) {
  const { children, ...other } = props;

  const itemData = children as unknown as React.ReactElement[];
  const itemSize = 48;
  const itemCount = itemData.length;

  const getHeight = () => (itemCount > 8 ? 8 * itemSize : itemCount * itemSize);
  const gridRef = useResetCache(itemCount);

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <VariableSizeList
          itemData={itemData as any}
          height={getHeight() + 2 * LISTBOX_PADDING}
          width="100%"
          ref={gridRef}
          outerElementType={OuterElementType}
          innerElementType="ul"
          itemSize={() => itemSize}
          overscanCount={5}
          itemCount={itemCount}
        >
          {renderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});

export default ListboxComponent;
